<template>
    <section
        ref="invitation"
        aria-labelledby="my-work-context-chat-title"
        class="flex flex-col justify-center rounded-lgr border border-border bg-surface-raised px-5 py-10 md:px-10 text-pretty">
        <div class="mx-auto flex max-w-225 flex-col items-center gap-6 text-center">
            <div class="flex flex-col items-center gap-4">
                <p v-if="hasVisibleInsights" class="scaffold-details-small text-ink-muted">{{ t("myWorkContextChat.label") }}</p>
                <h2 id="my-work-context-chat-title" class="nadia-subtitle text-ink text-balance">
                    {{ hasVisibleInsights ? t("myWorkContextChat.question") : exhausted ? t("myWorkContextChat.noMoreInsights") : t("myWorkContextChat.noInsights") }}
                </h2>
                <div class="body-small text-ink-muted flex flex-col gap-3">
                    <p>{{ t("myWorkContextChat.descriptionPrompts") }}</p>
                    <p>{{ t("myWorkContextChat.descriptionContext") }}</p>
                </div>
            </div>
            <HomeChatInput
                :pii-patterns="piiPatterns"
                compact
                text-only
                :auto-focus-input="false"
                :document-upload-enabled="false"
                default-chat-redirect-url="/coach/"
                start-chat-url="/v1/chat/start-my-work-context"
                :chat-source="CHATSOURCE.MY_WORK_CONTEXT"
                :location="CHAT_MESSAGE_CONTROLS_LOCATION.MY_WORK"
                :placeholder="t('myWorkContextChat.placeholder')"
                class="text-left" />
        </div>
    </section>
</template>

<script setup lang="ts">
import { useElementVisibility, whenever } from "@vueuse/core";
import HomeChatInput from "~vue/ChatHome/HomeChatInput.vue";
import { CHAT_MESSAGE_CONTROLS_LOCATION, CHATSOURCE } from "~vue/utils/constants";
import type { PatternEntry } from "~vue/utils/pii/keywordClassifier";
import { computed, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
    piiPatterns?: PatternEntry[] | null;
    visibleInsightCount: number;
    exhausted: boolean;
}>();
const emit = defineEmits<{ viewed: [] }>();
const hasVisibleInsights = computed(() => props.visibleInsightCount > 0);

const { t } = useI18n();
const invitation = useTemplateRef<HTMLElement>("invitation");
const inViewport = useElementVisibility(invitation);
whenever(inViewport, () => emit("viewed"), { once: true });
</script>
